import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultV2Vo} from '../../common/shared/api/nicolas/vo/ApiResultV2Vo.interface';
import {InvenResultVo} from '../../common/shared/api/nicolas/vo/inven/InvenResultVo.interface';

/**
 * 찜 목록 조회
 *
 * Origin: pageNicolasApi.getInvenLikeList
 * API: GET /api/v1/inven/like
 */
export async function getInvenLike(
  params: {
    category_uid?: number;
    sort_type?: string;
    page?: number;
    size?: number;
  },
  options?: FetcherOptions
): Promise<ApiResultV2Vo<InvenResultVo>> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/inven/like',
    {
      method: 'GET',
      params: {
        category_uid: params.category_uid ?? 0,
        sort_type: params.sort_type ?? 'like',
        page: params.page ?? 0,
        size: params.size ?? 25,
      },
    },
    options
  );
  return response.data;
}
